import React from "react";
import "leaflet/dist/leaflet.css";

import {MapContainer} from "react-leaflet";
import DraggableMarker from "../DraggableMarkers";
import ClickLocalizer from "../ClickLocalizer";
import TileLayersWithControl from "../TileLayersWithControl";

const validLatitudes = (lat) => {
    const latNum = parseFloat(lat);
    return !isNaN(latNum) && latNum >= -90 && latNum <= 90;
};

const validLongitudes = (lng) => {
    const lngNum = parseFloat(lng);
    return !isNaN(lngNum) && lngNum >= -180 && lngNum <= 180;
}

const EditLatLngMap = ({lat, lng, onChange, center = [45.6, 9.7], zoom = 6, disabled, ...props}) => {
    return <MapContainer center={center}
                         zoom={zoom}
                         {...props}>
        <TileLayersWithControl />
        {
            validLatitudes(lat) && validLongitudes(lng) && <DraggableMarker lat={lat} lng={lng} onDragEnd={onChange}
                                                                            disabled={disabled}/>
        }
        <ClickLocalizer onClick={onChange} disabled={disabled}/>
    </MapContainer>
}

export default EditLatLngMap;